import * as XLSX from "xlsx";
import { Button } from "@mui/material";
import dayjs from "dayjs";

const planVsActualExportButton = (shiftsFetchedData, mainFetchedData, opelogFetchedData) => {
    const wb = XLSX.utils.book_new(); // Create a new Excel workbook
        const formatDate = (dateString) => {
            return dateString ? dayjs(dateString).format("YYYY-MM-DD") : "N/A";
        };
    
        const formatDateTime = (dateString) => {
            return dateString ? dayjs(dateString).format("YYYY-MM-DD HH:mm:ss") : "N/A";
        };

    if (shiftsFetchedData.length > 0) {
        const formattedShifts = shiftsFetchedData.map(row => ({
            ...row,
            planvsactualDate: formatDate(row.planvsactualDate),
        }));
        const wsShifts = XLSX.utils.json_to_sheet(formattedShifts);
        XLSX.utils.book_append_sheet(wb, wsShifts, "Shift Logs");
    }

    if (mainFetchedData.length > 0) {
        const formattedMain = mainFetchedData.map(row => ({
            ...row,
            created_at: formatDateTime(row.created_at),
            updated_at: formatDateTime(row.updated_at),
            FilterEndDate: formatDate(row.FilterEndDate),
        }));
        const wsMain = XLSX.utils.json_to_sheet(formattedMain);
        XLSX.utils.book_append_sheet(wb, wsMain, "Main Data");
    }

    if (opelogFetchedData.length > 0) {
        const formattedOpeLog = opelogFetchedData.map(row => ({
            ...row,
            created_at: formatDateTime(row.created_at),
            updated_at: formatDateTime(row.updated_at),
        }));
        const wsOpeLog = XLSX.utils.json_to_sheet(formattedOpeLog);
        XLSX.utils.book_append_sheet(wb, wsOpeLog, "Operation Logs");
    }

    // Save file
    XLSX.writeFile(wb, "PlanVsActualData.xlsx");
};

const ExportButton = ({ shiftsFetchedData, mainFetchedData, opelogFetchedData }) => {
    if (shiftsFetchedData.length === 0 && mainFetchedData.length === 0 && opelogFetchedData.length === 0) {
        return null;
    }

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={() => planVsActualExportButton(shiftsFetchedData, mainFetchedData, opelogFetchedData)}
            // sx={{ mt: 2 }}
        >
            Download Excel
        </Button>
    );
};

export { planVsActualExportButton, ExportButton };
